"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLocale = exports.Locale = void 0;
/**
 * Locales are defined using IETF language tags
 * @see https://en.wikipedia.org/wiki/IETF_language_tag
 * @see https://en.wikipedia.org/wiki/ISO_3166-1
 */
var Locale;
(function (Locale) {
    Locale["DE_DE"] = "de-DE";
    Locale["EN_GB"] = "en-GB";
    Locale["EN_US"] = "en-US";
    Locale["ES_ES"] = "es-ES";
    Locale["FA_IR"] = "fa-IR";
    Locale["FR_FR"] = "fr-FR";
    Locale["PL_PL"] = "pl-PL";
    Locale["RO_RO"] = "ro-RO";
    Locale["TR_TR"] = "tr-TR";
})(Locale || (exports.Locale = Locale = {}));
const locales = Object.values(Locale);
const isLocale = (locale) => locales.includes(locale);
exports.isLocale = isLocale;
